import React, { Component } from 'react';
import { BaasicModal } from 'core/components';
import { ModalParams } from 'core/models';
import { ImportValidationModal } from 'application/import/components';

class ConfirmationCellTemplate extends Component {
    constructor(props){
        super();
        
        this.props = props;
        this.validationItem = this.props.dataItem;
        this.importValidationModal = new ModalParams({onClose:() => this.onCloseImportValidation()});
        
    }

    render(){
        let validations = this.props.dataItem.importValidations.map(item => {
            return(item.validation && item.validation.validationType && 
                <span>
                    <a onClick={()=> this.onOpenImportValidation(this.props.dataItem)}>
                        <i 
                            className={`u-icon u-icon--med-lrg u-icon--${item.validation.validationType.abrv}`}
                            title={item.message ? item.message : item.validation.name}
                            >
                        </i>
                    </a>
                </span>
            );
        })
        return (
            <td className="table__body--data left">
                {validations}
                <BaasicModal modalParams={this.importValidationModal} className="modal__content ReactModal__Content--med">
                    <ImportValidationModal />
                </BaasicModal>
            </td>
        );
    }
        
    onOpenImportValidation(item){
        this.importValidationModal.open({ 
            item: item,
        });
    }

    onCloseImportValidation(){

        this.importValidationModal.isOpen = false;
    }
}

export default ConfirmationCellTemplate;